import { InMemoryCache, TypePolicies } from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';

import possibleTypes from '@/graphql/fragments/fragmentTypes.json';

const typePolicies: TypePolicies = {
  Viewer: {
    fields: {
      companiesRecommendations: relayStylePagination(),
      followedCompanies: relayStylePagination(),
      managedCompanies: relayStylePagination(),
    },
  },
  Mergeable: {
    merge: true,
  },
};

export const cache = new InMemoryCache({
  possibleTypes,
  typePolicies,
});

export const getNewCache = () =>
  new InMemoryCache({
    possibleTypes,
    typePolicies,
  });
